import { updateViewImageDataByID } from "../database/offlineDb/indexDb";

export const persistViewImagesStatusProjection = async ({
  row,
  publish,
  isCurrent = () => true,
}) => {
  if (!row?.guid || typeof publish !== "function") {
    throw new TypeError("View Images row and publisher are required");
  }
  const updated = await updateViewImageDataByID(row.guid, row);
  if (!isCurrent()) return null;
  if (updated !== 1) {
    throw new Error("View Images row was not durably updated");
  }
  await publish(row);
  return row;
};
